import { track } from 'modules/core/lib/Tracking'

export type EventPayload = {
  page_path: string
  page_url: string
  form_number_of_employees: number | undefined
  from: string
  href?: string
}

const useExternalLinks = () => {
  const handleExternalClick = (eventName: string, eventPayload: EventPayload, link: string) => {
    track(eventName, {
      ...eventPayload,
      href: link,
    })
    window.open(link, '_blank')
  }

  return { handleExternalClick }
}

export default useExternalLinks
